import { render, staticRenderFns } from "./SaleAdminDetail.vue?vue&type=template&id=22a31d7c&"
import script from "./SaleAdminDetail.vue?vue&type=script&lang=js&"
export * from "./SaleAdminDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports